export const version = "properties/5.8.0";
//# sourceMappingURL=_version.js.map